module.exports = __webpack_public_path__ + "img/whatsapp.0bf0c13.svg";